// 题型
export const CHOICE = 'CHOICE'; // 选择题
export const BLANK_FILLING = 'BLANK_FILLING'; // 填空题
export const SORT = 'SORT'; // 排序题
export const JUDGEMENT = 'JUDGEMENT'; // 判断题
export const CONNECTION = 'CONNECTION'; // 连线题
export const WRITING = 'WRITING'; // 写作题
export const SPELL = 'SPELL'; // 拼写题
export const DSR = 'DSR'; // DSR题
export const INTERPRET = 'INTERPRET'; // 口译题
export const COMPOSITION = 'COMPOSITION'; // 阅读理解
export const OPEN = 'OPEN'; // 开放题
const BLANK_TYPES = ['BLANK_FILLING', 'CLOZE', 'SELECTION_BLANK_FILLING'];

// 模板配置block类型
export const QUESTION = 'QUESTION'; // 题干
export const EXPLANATION = 'EXPLANATION'; // 解析
export const OPTION = 'OPTION'; // 选项
export const NONE = 'NONE'; // 普通block
export const GROUP = 'GROUP'; // 组

export const exerciseTypeMap = {
  CHOICE: '单项选择题',
  MULTIPLE_ANSWER: '多项选择题',
  RECORDING_MULTIPLE_CHOICE: '录音选择题',
  SUBJECTIVE_MULTIPLE_CHOICE: '主观选择题',
  BLANK_FILLING: '短文本填空',
  CLOZE: '完型填空',
  SELECTION_BLANK_FILLING: '选择填空',
  JUDGEMENT: '判断题',
  SORT: '排序题',
  CONNECTION: '连线题',
  WRITING: '写作题',
  SPELL: '拼写题',
  DSR: '语音题',
  INTERPRET: '口译题',
  COMPOSITION: '复合题',
  OPEN: '开放题',
  COMBINE: '连词连句',
  COMBINE_AND_DSR: '连词连句跟读',
  SYLLABLE_CHOICE_AND_DSR: '音节跟读',
};

export interface ExerciseType {
  type: string;
  name: string;
}

export const exerciseTypeList: ExerciseType[] = Object.entries(exerciseTypeMap).map(
  ([key, value]) => ({
    type: key,
    name: value,
  })
);

export const EXERCISE = 'EXERCISE';
export const NORMAL = 'NORMAL';
export const GAME = 'GAME';
export type ModuleTemplateType = 'NORMAL' | 'EXERCISE' | 'EXPLANATION'| 'GAME';
export const isBlankType = inType => BLANK_TYPES.includes(inType);
